import { Icon } from '@/components'
import { ButtonLink } from '@/components/Button'
import CloudinaryImage from '@/components/CloudinaryImage'
import PinElements from '@/components/PinElements'
import { classNames } from '@/util/tailwindHelpers'
import { ComponentPropsWithoutRef } from 'react'
import { ARCADE_OVERVIEW_BACKGROUND_CLOUDINARY_PATH } from '../../constants'
import {
  OVERVIEW_CONVERT_PATH,
  OVERVIEW_POINT_VALUES_PATH,
  OVERVIEW_TIMELINE_PATH
} from '../../hooks/routing'

const steps = [
  {
    number: '1',
    title: 'COLLECT!',
    description:
      'Collect eligible digital collectibles to convert into Arcade Points.',
    linkText: "WHAT'S ELIGIBLE TO CONVERT?",
    linkUrl: OVERVIEW_CONVERT_PATH
  },
  {
    number: '2',
    title: (
      <div className="flex gap-[6px] items-center">
        CONVERT TO POINTS
        <Icon name="arcade" className="w-[18px] h-[18px]" />
      </div>
    ),
    description:
      'From your Inventory, convert items to Arcade Points. Each rarity has a unique point value, which you can see on the item’s detail pane.',
    linkText: 'VIEW POINT VALUES',
    linkUrl: OVERVIEW_POINT_VALUES_PATH
  },
  {
    number: '3',
    title: 'CLIMB THE LEADERBOARD',
    description:
      'Stay in the top 333 ranks by the end-of-season snapshot to be eligible for a redemption token. View the prize wall to see all available prizes.',
    linkText: 'VIEW TIMELINE',
    linkUrl: OVERVIEW_TIMELINE_PATH
  }
]

const ArcadeOverviewHowToPlay = ({
  className
}: ComponentPropsWithoutRef<'div'>) => {
  return (
    <div
      className={classNames(
        'container flex flex-col gap-4 w-full items-center',
        className
      )}
    >
      <h2 className="h2">How to Play</h2>
      <PinElements
        pins={{
          className: 'max-lg:hidden',
          items: [
            {
              element: (
                <CloudinaryImage
                  imageId={'tongue'}
                  transformations={{ format: 'svg' }}
                  path={ARCADE_OVERVIEW_BACKGROUND_CLOUDINARY_PATH}
                  width={223}
                  height={325}
                />
              ),
              anchor: {
                x: 100,
                y: 0
              },
              position: {
                x: 8,
                y: 90
              }
            }
          ]
        }}
      >
        <div className="flex flex-wrap gap-4 items-center justify-center min-[704px]:items-stretch">
          {steps.map((step, index) => (
            <div
              key={index}
              className="bg-[var(--backgroundColor)] relative flex flex-col gap-1 items-center mt-2 min-[704px]:min-h-[248px] min-[704px]:items-start text-center min-[704px]:text-left p-4 pt-6 rounded-[32px] border border-gray-800 max-w-[320px]"
            >
              <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 flex items-center justify-center w-6 h-6 bg-arcadeGreen text-black text-lg font-bold rounded-full">
                {step.number}
              </div>
              <h5 className="h5">{step.title}</h5>
              <p className="text-gray-300 body">{step.description}</p>
              <ButtonLink
                href={step.linkUrl}
                theme="clean-arcade"
                className=" mt-2 min-[704px]:absolute min-[704px]:bottom-4"
              >
                {step.linkText}
              </ButtonLink>
            </div>
          ))}
        </div>
      </PinElements>
      <div className="flex justify-center">
        <ButtonLink size="lg" href="faq/#arcade" theme="secondary">
          VIEW ARCADE FAQ
        </ButtonLink>
      </div>
      <div className="flex justify-center">
        <ButtonLink href="/terms/arcade" target="_blank" theme="clean-gray">
          View all official Droppp Arcade rules
        </ButtonLink>
      </div>
    </div>
  )
}

export default ArcadeOverviewHowToPlay
